import { Form, Formik } from "formik";
import Flatpickr from "react-flatpickr";
import * as Yup from "yup";
import { CMFormDropDown, CMFormInput, handleError, handleKeyDownNumber, notifyError, notifySuccess } from "../../MethodMaster/JSXComponentMothod";
import { Modal } from "react-bootstrap";
import { useSetNewMember } from "../../API_Master/MutateAPI";
import Loader from "../../CommonComponents/Loader";
import { toast } from "react-toastify";
import DynamicRadioGroup from "../../CommonComponents/DynamicRadio.jsx";
import Cookies from "js-cookie";

const AddNewVoter = ({ show, onClose, onSubmit, initialData, refetch, familyHeadMasterID }) => {
  const { mutate: addNewMember, isPending: inserting } = useSetNewMember();

  if (!show) return null;

  const initialValues = initialData || {
    firstName: "",
    middleName: "",
    lastName: "",
    mobileNo: "",
    serialNo: "",
    idCardNo: "",
    gender: "Male",
    age: "",
    birthDate: "",
    handicap: "No",
    outside: "No",
  };

  const validationSchema = Yup.object({
    firstName: Yup.string().required("First Name is required"),
    lastName: Yup.string().required("Last Name is required"),
    mobileNo: Yup.string()
      .matches(/^[0-9]{10}$/, "Mobile number must be 10 digits")
      .required("Mobile No is required"),
    age: Yup.number().min(0, "Age must be at least 0").max(120, "Age must be at most 120").required("Age is required"),
    idCardNo: Yup.string().required("Id Card No is required"),
    gender: Yup.string().required("Gender is required"),
    handicap: Yup.string().required("Handicap is required"),
    outside: Yup.string().required("Outside is required"),
  });

  const genderOptions = [
    { label: "Male", value: "Male" },
    { label: "Female", value: "Female" },
  ];

  const handicapOptions = [
    { label: "Yes", value: "Yes" },
    { label: "No", value: "No" },
  ];
  const outsideOptions = [
    { label: "Yes", value: "Yes" },
    { label: "No", value: "No" },
  ];
  return (
    <>
      <Modal show={show} centered={true} size="lg" dialogClassName="custom-modal-width" id="modalCenter" tabIndex={-1} role="dialog">
        <div className="modal-header">
          <h5 className="modal-title">Add Member</h5>
          <button type="button" className="btn-close" onClick={onClose}></button>
        </div>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={(values) => {
            toast.dismiss();
            const genderValue = values?.gender?.toLowerCase() === "male" ? "m" : "f";
            const handicapValue = values?.handicap?.toLowerCase() === "yes" ? true : values?.handicap?.toLowerCase() === "no" ? false : null;
            const outsideValue = values?.outside?.toLowerCase() === "yes" ? true : values?.outside?.toLowerCase() === "no" ? false : null;
            const payload = {
              UserID: Cookies.get("Mukesh_Patel_UserID") || "",
              FirstNameEnglish: values?.firstName || "",
              MiddleNameEnglish: values?.middleName || "",
              LastNameEnglish: values?.lastName || "",
              FullNameEnglish: `${values?.firstName || ""} ${values?.middleName || ""} ${values?.lastName || ""}`.trim(),
              MobileNo: values?.mobileNo || "",
              SLNo: values?.serialNo || "",
              BirthDate: values?.birthDate || "",
              IDCardNo: values?.idCardNo || "",
              Gender: genderValue || "",
              Age: values?.age || "",
              IsHandicap: handicapValue,
              IsOutSide: outsideValue,
              FamilyHeadMasterID: familyHeadMasterID || "",
              // CreatedByUserID: Cookies.get("Mukesh_Patel_UserID") || "",
            };
            addNewMember(payload, {
              onSuccess: (res) => {
                if (res?.status === true) {
                  notifySuccess("Successfully Inserted", false);
                  refetch();
                  onClose();
                } else {
                  notifyError(res?.message ? res.message : "Data Not Inserted", false);
                }
              },
              onError: (err) => {
                const errorMessage = err?.message || "Failed to assign system";
                console.error(err);
                notifyError(errorMessage || "Something went wrong", false);
              },
            });
          }}
        >
          {({ values, errors, touched, setFieldValue }) => {
            console.log("errorsErrorsErrors", errors);
            return (
              <Form>
                <div className="modal-body">
                  <div className="row g-3">
                    <CMFormInput
                      InputLabel={"First Name"}
                      id={"firstName"}
                      required={true}
                      ColSize="col-md-4 sm-12 mb-2"
                      temptVal={values.firstName}
                      type={"text"}
                      maxLength={100}
                      handleError={() => handleError({ errors, touched }, `firstName`)}
                      handleDispatch={(e) => setFieldValue("firstName", e.target.value)}
                    />
                    <CMFormInput
                      InputLabel={"Middle Name"}
                      id={"middleName"}
                      //   required={true}
                      ColSize="col-md-4 sm-12 mb-2"
                      temptVal={values.middleName}
                      type={"text"}
                      maxLength={50}
                      handleError={() => handleError({ errors, touched }, `middleName`)}
                      handleDispatch={(e) => setFieldValue("middleName", e.target.value)}
                    />
                    <CMFormInput
                      InputLabel={"Last Name"}
                      id={"lastName"}
                      required={true}
                      ColSize="col-md-4 sm-12 mb-2"
                      temptVal={values.lastName}
                      type={"text"}
                      maxLength={50}
                      handleError={() => handleError({ errors, touched }, `lastName`)}
                      handleDispatch={(e) => setFieldValue("lastName", e.target.value)}
                    />
                    <CMFormInput
                      InputLabel={"Mobile No"}
                      id={"mobileNo"}
                      required={true}
                      ColSize="col-md-4 sm-12 mb-2"
                      temptVal={values.mobileNo}
                      type={"text"}
                      maxLength={10}
                      onKeyDown={handleKeyDownNumber}
                      handleError={() => handleError({ errors, touched }, `mobileNo`)}
                      handleDispatch={(e) => setFieldValue("mobileNo", e.target.value)}
                    />
                    <CMFormInput
                      InputLabel={"Serial No"}
                      id={"serialNo"}
                      //   required={true}
                      ColSize="col-md-4 sm-12 mb-2"
                      temptVal={values.serialNo}
                      type={"text"}
                      maxLength={50}
                      handleError={() => handleError({ errors, touched }, `serialNo`)}
                      handleDispatch={(e) => setFieldValue("serialNo", e.target.value)}
                    />
                    <CMFormInput
                      InputLabel={"Id Card No"}
                      id={"idCardNo"}
                      required={true}
                      ColSize="col-md-4 sm-12 mb-2"
                      temptVal={values.idCardNo}
                      type={"text"}
                      maxLength={16}
                      handleError={() => handleError({ errors, touched }, `idCardNo`)}
                      handleDispatch={(e) => setFieldValue("idCardNo", e.target.value)}
                    />

                    {/* <CMFormDropDown
                      InputLabel={"Gender"}
                      IsFormikInput={true}
                      requiredStar={true}
                      valueTempt={values?.gender}
                      ColSize="col-md-4 sm-12 mb-n3"
                      handleError={() => handleError({ errors, touched }, `gender`)}
                      options={[
                        { label: "-- Select gender --", value: "" },
                        { label: "Male", value: "Male" },
                        { label: "Female", value: "Female" },
                      ]}
                      handleDispatch={(e) => setFieldValue("gender", e?.value)}
                      id="gender"
                    /> */}
                    <div className="col-md-4 sm-12 mb-2">
                      <DynamicRadioGroup
                        options={genderOptions}
                        name={"gender"}
                        required={true}
                        value={values?.gender}
                        handleError={() => handleError({ errors, touched }, `gender`)}
                        label={"Gender"}
                        onChange={(e) => {
                          setFieldValue("gender", e.target?.value);
                        }}
                      />
                    </div>
                    <CMFormInput
                      InputLabel={"Age"}
                      id={"age"}
                      required={true}
                      ColSize="col-md-4 sm-12 mb-2"
                      temptVal={values.age}
                      type={"text"}
                      maxLength={3}
                      handleError={() => handleError({ errors, touched }, `age`)}
                      handleDispatch={(e) => setFieldValue("age", e.target.value)}
                    />

                    <div className="col-sm-4 col-md-4 ">
                      <label className="form-label">Birth Date</label>
                      <Flatpickr
                        options={{ dateFormat: "d-m-Y" }}
                        value={values?.birthDate}
                        id="birthDate"
                        name="birthDate"
                        className="form-control"
                        onChange={(e) => {
                          setFieldValue("birthDate", e.target);
                          //   handleFilterDateChange(e, "birthDate");
                        }}
                        placeholder="DD-MM-YYYY"
                      />
                      {touched["birthDate"] && errors["birthDate"] ? (
                        <div style={{ fontSize: "0.9em" }} className="text-danger text-left  ">
                          <strong>{errors["birthDate"]}</strong>
                        </div>
                      ) : null}
                    </div>
                    {/* <CMFormDropDown
                      InputLabel={"Handicap"}
                      IsFormikInput={true}
                      requiredStar={true}
                      valueTempt={values?.handicap}
                      ColSize="col-md-4 sm-12 mb-n3"
                      handleError={() => handleError({ errors, touched }, `handicap`)}
                      options={[
                        { label: "-- Select MainSite --", value: "" },
                        { label: "Yes", value: "Yes" },
                        { label: "No", value: "No" },
                      ]}
                      handleDispatch={(e) => setFieldValue("handicap", e?.value)}
                      id="Location"
                    /> */}
                    <div className="col-md-4 sm-12 mb-2">
                      <DynamicRadioGroup
                        options={handicapOptions}
                        name={"handicap"}
                        required={true}
                        value={values?.handicap}
                        handleError={() => handleError({ errors, touched }, `handicap`)}
                        label={"Handicap"}
                        onChange={(e) => {
                          setFieldValue("handicap", e.target?.value);
                        }}
                      />
                    </div>
                    {/* <CMFormDropDown
                      InputLabel={"Outside"}
                      IsFormikInput={true}
                      requiredStar={true}
                      valueTempt={values?.outside}
                      ColSize="col-md-4 sm-12 mb-n3"
                      handleError={() => handleError({ errors, touched }, `outside`)}
                      options={[
                        { label: "-- Select OutSide --", value: "" },
                        { label: "Yes", value: "Yes" },
                        { label: "No", value: "No" },
                      ]}
                      handleDispatch={(e) => setFieldValue("outside", e?.value)}
                      id="outside"
                    /> */}
                    <div className="col-md-4 sm-12 mb-2">
                      <DynamicRadioGroup
                        options={outsideOptions}
                        name={"outside"}
                        required={true}
                        value={values?.outside}
                        handleError={() => handleError({ errors, touched }, `outside`)}
                        label={"Outside"}
                        onChange={(e) => {
                          setFieldValue("outside", e.target?.value);
                        }}
                      />
                    </div>
                  </div>
                </div>

                <div className="modal-footer">
                  {/* <button type="button" className="btn btn-secondary" onClick={onClose}>
                    Cancel
                  </button> */}
                  <button type="submit" className="btn btn-primary">
                    Save Member
                  </button>
                </div>
              </Form>
            );
          }}
        </Formik>
      </Modal>
      {inserting && <Loader />}
    </>
  );
};

export default AddNewVoter;
